import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import StandardPage from '../../containers/standard-page';

import Header from '../../blocks/header';
import SubNavigation from '../../blocks/sub-navigation';
import HeroCarousel from '../../blocks/hero-carousel';
import HeroVideo from '../../blocks/hero-video';
import HeroImage from '../../blocks/hero-image';
import SocialIconsContainerBlock from '../../containers/social-icons-container-block';
import SubFooterNavigation from '../../blocks/sub-footer-navigation';
import FooterNavigation from '../../containers/footer-navigation';
import CtaNavi from '../../containers/html';
import AnchorNavi from '../../containers/html';
import CookieEditor from '../../containers/html';
import FullWidth from '../../blocks/full-width';
import ExteriorView from '../../blocks/exterior-view';
import PhotoInfo from '../../containers/photo-info';
import TabNavigation from '../../containers/tab-navigation';
import SpecComparison from '../../blocks/spec-comparison';
import EcoTax from '../../containers/eco-tax';
import Photogallery from '../../blocks/photogallery';
import Video from '../../blocks/video';
import OneColumnLayout from '../../containers/one-column-layout';
import TwoColumnLayout from '../../containers/two-column-layout';
import ThreeColumnLayout from '../../containers/three-column-layout';
import FourColumnLayout from '../../containers/four-column-layout';
import AccessoryList from '../../containers/accessory-list';
import CtaNavigation from '../../containers/cta-navigation';
import AnchorNavigation from '../../containers/anchor-navigation';
import PromoAndButtonModalWindow from '../../containers/promo-and-button-modal-window';

const StandardPageBlock = props => <StandardPage {...props} />;
StandardPageBlock.displayName = 'StandardPage';

export default withDynamicComponents({
  componentWhitelist: [
    Header,
    SubNavigation,
    HeroCarousel,
    HeroVideo,
    HeroImage,
    SocialIconsContainerBlock,
    SubFooterNavigation,
    FooterNavigation,
    CtaNavi,
    AnchorNavi,
    CookieEditor,
    FullWidth,
    PhotoInfo,
    ExteriorView,
    TabNavigation,
    SpecComparison,
    EcoTax,
    Photogallery,
    Video,
    OneColumnLayout,
    TwoColumnLayout,
    ThreeColumnLayout,
    FourColumnLayout,
    AccessoryList,
    CtaNavigation,
    AnchorNavigation,
    PromoAndButtonModalWindow,
  ],
  mapInputToOutput: [
    ['header', 'header'],
    ['upperPageNavigation', 'upperPageNavigation'],
    ['hero', 'hero'],
    ['components', 'children'],
    ['lowerPageNavigation', 'lowerPageNavigation'],
    ['footer', 'footer'],
    ['ctaNavi', 'ctaNavi'],
    ['anchorNavi', 'anchorNavi'],
    ['cookieEditor', 'cookieEditor'],
  ],
})(StandardPageBlock);



// WEBPACK FOOTER //
// ./src/blocks/standard-page/index.jsx